import { render, staticRenderFns } from "./scope119.vue?vue&type=template&id=4524da14&scoped=true"
import script from "./scope119.vue?vue&type=script&lang=js"
export * from "./scope119.vue?vue&type=script&lang=js"
import style0 from "./scope119.vue?vue&type=style&index=0&id=4524da14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4524da14",
  null
  
)

export default component.exports